/* ZEPHIR - Capa editorial de la ficha de producto.
 *   A) Columna de fotos a sangre por la izquierda.
 *   B) Reticula de la galeria por ciclos (ver CICLO).
 *   C) Barra fija de compra: de abajo-centrada a arriba-a lo ancho.
 *   D) Acordeones al alto de la referencia y hairline de la paleta.
 *
 * (B) ES JS Y NO :nth-child PORQUE:
 *   La galeria la posiciona PACKERY en absoluto (window.Packery; la clase se
 *   llama isotopet4s pero Isotope es undefined). Cada foto trae inline
 *   "position:absolute; top:845.26px". Entonces:
 *     1. Cambiar anchos por CSS no reacomoda: hay que llamar layout().
 *     2. Al filtrar por color las ocultas salen del layout, y :nth-child cuenta
 *        TODOS los hermanos. El ciclo se calcula sobre las VISIBLES.
 *
 * DOS CORTES, NO UNO. La reticula y la barra no comparten ancho minimo:
 *   MIN_GRID 992 - reticula y sangrado. El tema pone dos columnas desde 768
 *     (t4s-col-md-6, verificado en base.css), asi que entre 768 y 991 la
 *     columna de fotos mide ~370px y una foto a media anchura quedaria en
 *     ~180px: ilegible. Ahi se deja la columna completa, que es lo que hace
 *     tambien la referencia en tablet.
 *   MIN_BAR 768 - barra fija y acordeones. Es un elemento superpuesto, no
 *     depende del ancho de la columna, y va acompasado con zephir-pdp-rl.js,
 *     que enciende la barra desde 768. Si los dos numeros se separan queda un
 *     estado a medias: la barra aparece abajo (posicion del tema) con la
 *     animacion de opacidad puesta.
 */
(function () {
  'use strict';

  var SEL = '[data-main-slide]', CLASE = 'zph-g-half';
  var MIN_GRID = 992, MIN_BAR = 768, ALTO = 70, propio = false;

  /* CICLO: cada ciclo cierra con DOS fotos a media anchura; las previas completas.
   *   4 -> completa, completa, mitad, mitad   (ritmo de la referencia)
   *   3 -> completa, mitad, mitad             (el de aqui)
   * Se usa 3 porque con el filtro por color cada color muestra solo SUS fotos y
   * ZEPHIR tiene 1-3 por color: con 4 el par casi nunca aparecia. Subirlo
   * cuando haya mas fotos por color es cambiar este numero y nada mas. */
  var CICLO = 3;

  /* SANGRADO: .t4s-product__media-wrapper esta en left:15 CON padding-left:15px
   * (dos aportes de 15). Hacen falta los dos: padding 0 + margen -15. Verificado
   * con elementFromPoint(2,y) -> IMG. El padding-right reparte foto/aire sin
   * mover la columna de texto.
   *
   * BARRA: el tema la deja abajo y centrada. Se sube bajo el header pegado
   * (--header-height 48px; medido hueco 0) y el bloque de compra va al borde con
   * margin-left:auto. Su boton venia ciruela #6B4B63 14px/600 y el principal es
   * #161616 12.5px/300 ls1.75: se igualan.
   *
   * ACORDEONES. Dos cosas que costaron medir:
   *   1. ESPECIFICIDAD. El tema trae
   *      .t4s-tabs .t4s-tab__title{padding:18px 0!important}  -> (0,2,0)
   *      Un .t4s-tab__title suelto es (0,1,0) y PIERDE aunque lleve !important:
   *      entre dos !important gana la especificidad. De ahi la cadena completa.
   *   2. QUIEN FIJA EL ALTO. No es el texto: es el ICONO. La fila es flex y su
   *      alto = el del hijo mas alto, y .t4s-tab__icon mide 44x44. Con los 36 de
   *      relleno del titulo daba 80-84px. Bajando el icono a 26 quedan ~62, el
   *      alto de la referencia, sin tocar tipografia ni relleno.
   *   El +/- SE CONSERVA: indica abierto/cerrado. La referencia usa flecha porque
   *   abre un cajon; aqui despliega en linea y sin el +/- se pierde el aviso.
   *   En movil el icono se deja en sus 44px: ahi manda el dedo, no el ritmo. */
  var s = document.createElement('style');
  s.textContent =
    '[data-main-slide].' + CLASE + '{width:50%!important;max-width:50%!important;flex:0 0 50%!important;}' +
    '@media (min-width:' + MIN_GRID + 'px){' +
      '.t4s-product__media-wrapper{padding-left:0!important;margin-left:-15px!important;padding-right:15px!important;}' +
    '}' +
    '@media (min-width:' + MIN_BAR + 'px){' +
      '.t4s-sticky-atc{top:var(--header-height,48px)!important;bottom:auto!important;justify-content:flex-start!important;align-items:stretch!important;padding:0!important;box-shadow:0 1px 0 rgba(0,0,0,.08);}' +
      '.t4s-sticky-atc__product{align-items:center!important;flex:1 1 auto!important;min-width:0;}' +
      '.t4s-sticky-atc__img,.t4s-sticky-atc__img img{width:' + ALTO + 'px!important;height:' + ALTO + 'px!important;}' +
      '.t4s-sticky-atc__infos{display:flex!important;flex-direction:column!important;justify-content:center!important;margin-left:22px!important;}' +
      '.t4s-sticky-atc__title{font-family:var(--font-family-2);font-size:17px;line-height:1.2;margin:0!important;}' +
      '.t4s-sticky-atc__price{font-size:13px;margin-top:2px!important;}' +
      '.t4s-sticky-atc__qty{display:none!important;}' +
      '.t4s-sticky-atc__btns{margin-left:auto!important;align-items:stretch!important;}' +
      '.t4s-sticky-atc__atc{height:' + ALTO + 'px!important;min-width:300px;border-radius:0!important;background:#161616!important;border-color:#161616!important;color:#fff!important;font-size:12.5px!important;letter-spacing:1.75px!important;font-weight:300!important;text-transform:uppercase;}' +
      '.t4s-tabs .t4s-tab-wrapper .t4s-tab__text{padding:0!important;}' +
      '.t4s-tabs .t4s-tab-wrapper .t4s-tab__icon{width:26px!important;height:26px!important;}' +
      '.t4s-tabs .t4s-tab-wrapper{border-bottom-color:var(--zephir-line,#e7e3df)!important;}' +
      '.t4s-tabs .t4s-tab-wrapper .t4s-tab__icon::before,.t4s-tabs .t4s-tab-wrapper .t4s-tab__icon::after{background:#161616!important;opacity:.5;}' +
    '}';
  document.head.appendChild(s);

  function cont() { var i = document.querySelector(SEL); return i ? i.parentElement : null; }

  function inst(c) {
    try {
      if (window.Packery && typeof window.Packery.data === 'function') {
        var p = window.Packery.data(c);
        if (p && typeof p.layout === 'function') return p;
      }
    } catch (e) {}
    return null;
  }

  function aplicar() {
    var c = cont();
    if (!c) return false;
    var todas = [].slice.call(c.querySelectorAll(SEL));
    if (!todas.length) return false;

    var p = inst(c);
    // Sin packery: carrusel (movil) o aun no arranco. No tocar anchos.
    var activo = !!p && window.innerWidth >= MIN_GRID;

    propio = true;
    todas.forEach(function (el) { el.classList.remove(CLASE); });
    if (activo) {
      var vis = todas.filter(function (el) { return !el.classList.contains('is--media-hide'); });
      // Las DOS ultimas posiciones de cada ciclo van a media anchura.
      vis.forEach(function (el, i) { if (i % CICLO >= CICLO - 2) el.classList.add(CLASE); });
      // Ciclo final incompleto por una posicion: esa mitad quedaria sola.
      if (vis.length % CICLO === CICLO - 1) vis[vis.length - 1].classList.remove(CLASE);
    }
    propio = false;

    if (p) { try { p.layout(); } catch (e) {} }
    return activo;
  }

  var n = 0;
  function arrancar() { if (aplicar() || ++n > 30) { observar(); return; } setTimeout(arrancar, 250); }

  // El filtro por color mueve is--media-hide: recalcular sobre las visibles.
  function observar() {
    var c = cont();
    if (!c || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function (ms) {
      if (propio) return;
      var ok = ms.some(function (m) {
        return m.type === 'attributes' && m.attributeName === 'class' &&
               m.target.hasAttribute && m.target.hasAttribute('data-main-slide');
      });
      if (!ok) return;
      clearTimeout(t);
      t = setTimeout(aplicar, 60);
    }).observe(c, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  var r = null;
  window.addEventListener('resize', function () { clearTimeout(r); r = setTimeout(aplicar, 200); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
